module.exports = __webpack_public_path__ + "static/img/12.f34b4dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/12.png
// module id = Vb+k
// module chunks = 0